module.exports = __webpack_public_path__ + "cf82380f62a9cbf0ddcb04614224f21d.pdf";